import { LoggedInUser } from "@/contexts/user/UserContext";
import { ROUTING } from "@/utils/constants/routing";

const AUTH_GUEST_ROUTES = [
  ROUTING.LOGIN,
  ROUTING.REGISTER,
  ROUTING.REGISTER_JOIN,
  ROUTING.FORGOT_PASSWORD,
  ROUTING.RESET_PASSWORD,
] as const;

function isAuthGuestRoute(pathname: string): boolean {
  return (AUTH_GUEST_ROUTES as readonly string[]).includes(pathname);
}

function needsOwnerProfileSetup(
  user: Pick<LoggedInUser, "ownerProfileComplete">,
): boolean {
  return user.ownerProfileComplete === false;
}

function getPostAuthRoute(user: LoggedInUser): string {
  if (needsOwnerProfileSetup(user)) {
    return ROUTING.ONBOARDING_ORGANIZATION;
  }

  return ROUTING.DASHBOARD.ROOT;
}

export { AUTH_GUEST_ROUTES, getPostAuthRoute, isAuthGuestRoute, needsOwnerProfileSetup };
